import { render, staticRenderFns } from "./requirementsTable.vue?vue&type=template&id=63511088&scoped=true"
import script from "./requirementsTable.vue?vue&type=script&lang=js"
export * from "./requirementsTable.vue?vue&type=script&lang=js"
import style0 from "./requirementsTable.vue?vue&type=style&index=0&id=63511088&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63511088",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/CloseProject/requirementsTable.vue
// module id = 1980
// module chunks = 31